<template>
  <iTextInput
    v-model="value"
    :width="getOptionValue(LayoutWidth)"
    :label="labelValue"
    :placeholder="placeholderValue"
    :prefix="getOptionValue(InputPrefix)"
    :type="getOptionValue(InputType)"
    :style-overrides="inputStyleOverrides"
    @blur="commitOnBlur"
  />
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import SeedField from "%/dynamic-component-editor/options/seed-field";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import Label from "%/dynamic-component-editor/options/label";
import InputPrefix from "%/dynamic-component-editor/options/input-prefix";
import InputType from "%/dynamic-component-editor/options/input-type";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";
import {
  APP_INPUT_BORDER_COLOR_DEFAULTS,
  APP_INPUT_BORDER_RADIUS_DEFAULTS,
  APP_INPUT_BORDER_WIDTH_DEFAULTS,
  DynamicAppInputFocusState,
} from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-states";

export default {
  name: "DynamicAppTextInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  availableStates: [DynamicAppInputFocusState],
  options: [
    CommitAction,
    SeedField,
    Placeholder,
    Label,
    InputPrefix,
    InputType,
    BackgroundColor,
    new BorderColor(APP_INPUT_BORDER_COLOR_DEFAULTS),
    new BorderWidth(APP_INPUT_BORDER_WIDTH_DEFAULTS),
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({}, {
      "layout-height": true,
      "max-width": true,
      "max-height": true,
      "min-width": true,
      "min-height": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions(APP_INPUT_BORDER_RADIUS_DEFAULTS, {
      "border-radius": false,
    }),
  ],
  computed: {
    LayoutWidth() {
      return LayoutWidth;
    },
    InputPrefix() {
      return InputPrefix;
    },
    InputType() {
      return InputType;
    },
    placeholderValue() {
      return this.appInputResolvedValue(this.getOptionValue(Placeholder)) ?? "";
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    inputStyleOverrides() {
      const padding = this.appInputPadding;
      return this.appInputStyleOverrides({
        borderRadius: this.appInputBorderRadius,
        inputBorderRadius: this.appInputBorderRadius,
        inputBorderFocusRadius: this.appInputFocusBorderRadius,
        inputBorderFocusColor: this.appInputFocusBorderColor,
        inputBorderFocusWidth: this.appInputFocusBorderWidth,
        inputBackgroundColor: this.appInputBackgroundColor,
        inputHoverBackgroundColor: this.appInputBackgroundColor,
        inputBorderColor: this.appInputBorderColor,
        inputBorderWidth: this.appInputBorderWidth,
        inputFontColor: this.appInputFontColor,
        inputFontWeight: this.appInputFontWeight,
        standardInputFontSize: this.appInputFontSize,
        standardInputPaddingTop: padding.top ?? null,
        standardInputPaddingBottom: padding.bottom ?? null,
        standardInputPaddingLeft: padding.left ?? null,
        standardInputPaddingRight: padding.right ?? null,
      });
    },
    value: {
      get() {
        const draft = this.valueFromContext;
        if (draft === null || draft === undefined || draft === "") {
          return this.appInputSeededValue;
        }
        return draft;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
  methods: {
    async commitOnBlur() {
      await this.$nextTick();
      this.triggerNamedAction(this.getOptionValue(CommitAction));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
